import { useAppDispatch } from '../store';
import { setUserPromptMessage } from '../store/slices/application-data';

export interface IContext {
  show: boolean;
  text: string;
}

let resolveCallback;

function usePrompt() {
  const dispatch = useAppDispatch();
  const fuelPrompt = async (text): Promise<boolean> => {
    await dispatch(setUserPromptMessage(text));

    return new Promise((res, rej) => {
      resolveCallback = res;
    });
  };

  const onConfirm = async (value: string) => {
    await dispatch(setUserPromptMessage(null));
    resolveCallback(value);
  };

  const onCancel = async () => {
    await dispatch(setUserPromptMessage(null));
    resolveCallback(null);
  };

  return { fuelPrompt, onConfirm, onCancel };
}

export default usePrompt;
